import axios from "axios";

// The contact form posts to the Netlify Function that is served (via a redirect
// in netlify.toml) at the same origin under /api/contact. A relative path means
// there is no build-time API URL to configure.
export async function submitContact(payload) {
  const { data } = await axios.post("/api/contact", payload, {
    headers: { "Content-Type": "application/json" },
  });
  return data;
}
